import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Soyut "sinyal / nabız" markası — oyun teması yok.
export function LogoMark({ size = 22 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="1" y="1" width="22" height="22" rx="7" stroke="var(--accent)" strokeOpacity="0.35" />
      <path
        d="M4 13.5h3.2l2-6.2 3 12 2.4-8 1.6 2.7H20"
        stroke="var(--accent)"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function Logo({ to = '/', size = 22 }) {
  const { t } = useTranslation();
  const inner = (
    <>
      <LogoMark size={size} />
      {t('brand')}
    </>
  );
  if (!to) return <span className="brand">{inner}</span>;
  return (
    <Link to={to} className="brand">
      {inner}
    </Link>
  );
}
